import { Typography } from '@mui/material';

import clsx from 'src/utils/clsx';
import { formatCurrency } from 'src/utils/formatCurrency';
import { formatDecimalTime } from 'src/utils/date';
import Alert from 'src/components/TimeTracking/components/Alert';

import styles from './styles';

type AdjustmentViewer = 'talent' | 'organization';

const PAY_PERIOD_OWNER: Record<AdjustmentViewer, string> = {
  talent: 'your',
  organization: "the Talent's",
};

type AlertPayPeriodAmountChangedProps = {
  originalHours: number;
  newHours: number;
  // the money the change of hours adds or takes off; the hours decide which of the two it says
  amount: number;
  viewer?: AdjustmentViewer;
};

const AlertPayPeriodAmountChanged: React.FC<AlertPayPeriodAmountChangedProps> = props => {
  const { originalHours, newHours, amount, viewer = 'talent' } = props;
  const payPeriodOwner = PAY_PERIOD_OWNER[viewer];

  const timeDiff = newHours - originalHours;
  const isOriginalEqualNewHours = timeDiff === 0;

  const hours = Math.abs(timeDiff);

  const alertVariant = timeDiff >= 0 ? 'disabled' : 'error';
  const isErrorVariant = alertVariant === 'error';
  const isDisabledVariant = alertVariant === 'disabled';

  const formattedHours = formatDecimalTime(hours.toString());
  const formattedAmount = formatCurrency(Math.abs(amount));

  let AlertContent = null;

  if (isErrorVariant) {
    AlertContent = (
      <Typography>
        You have reduced the number of hours:{' '}
        <Typography sx={styles.boldText} component="span">
          &minus;{formattedHours}
        </Typography>{' '}
        hours.{`\n`}
        <Typography sx={clsx(styles.boldText, [[styles.errorText, true]])} component="span">
          {formattedAmount}
        </Typography>{' '}
        will be deducted from {payPeriodOwner} next Pay Period amount.
      </Typography>
    );
  }

  if (isDisabledVariant) {
    AlertContent = (
      <Typography>
        You have increased the number of hours:{' '}
        <Typography sx={styles.boldText} component="span">
          {formattedHours}
        </Typography>{' '}
        hours.{`\n`}
        <Typography sx={styles.boldText} component="span">
          {formattedAmount}
        </Typography>{' '}
        will be added to {payPeriodOwner} next Pay Period amount.
      </Typography>
    );
  }

  return AlertContent && !isOriginalEqualNewHours && <Alert variant={alertVariant}>{AlertContent}</Alert>;
};

export default AlertPayPeriodAmountChanged;
